export const CUSTOM_EXAM_AUTO_APPROVE_DAYS = 5

export const CUSTOM_EXAM_EXCEPTION_REASONS = [
  {
    value: 'medical_health',
    label: 'Serious illness, injury, or required medical treatment'
  },
  {
    value: 'family_emergency',
    label: 'Bereavement or serious family emergency'
  },
  {
    value: 'force_majeure',
    label: 'Natural disaster, safety emergency, or official travel restriction'
  },
  {
    value: 'other_exceptional',
    label: 'Other exceptional circumstance'
  }
]
